import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "grid",
  id: "accountGrid"
}
const _hoisted_2 = { class: "text-muted no-mobile" }
const _hoisted_3 = {
  key: 0,
  class: "flex align-center justify-center g6 text-muted no-mobile"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"brightness(50%)"},
  src: "ico/stores.svg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WideCard = _resolveComponent("WideCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: account.ref!.id
      }, [
        (account.active || _ctx.unactives)
          ? (_openBlock(), _createBlock(_component_WideCard, {
              key: 0,
              click: () => _ctx.onAccountClick(account),
              active: account.active == undefined ? false : account.active,
              icon: 
          account.illustration_url == null
            ? _ctx.getDefaultIllustration(account)
            : account.illustration_url.get()
        ,
              title: account.name + ' ' + account.surname
            }, {
              subtitle: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(account.email), 1)
              ]),
              footer: _withCtx(() => [
                (account.role != _ctx.Role.Manager)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(account.stores.length) + " ", 1),
                      _hoisted_4
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["click", "active", "icon", "title"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}